import { useInView as useInViewLib } from 'react-intersection-observer';
import browserSupport from '../util/browser-support';
export var useInView = function useInView(options) {
  var hookResult = useInViewLib(options);
  if (!browserSupport.supportsIntersectionObserver) {
    // Unsupported, return no `ref` and default `inView` true value
    return [undefined, true];
  }
  return hookResult;
};